import { render, staticRenderFns } from "./NumberInput.vue?vue&type=template&id=2f1bded8"
import script from "./NumberInput.vue?vue&type=script&lang=ts"
export * from "./NumberInput.vue?vue&type=script&lang=ts"
import style0 from "./NumberInput.vue?vue&type=style&index=0&id=2f1bded8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports